import formatPayload from './formatPayload';
export default formatPayload;
